import { FieldViewModel, ICropping, IField } from "../omnia"
import { FieldsEditTarget, IFieldsEditService, IFieldsService } from "../types"

export class FieldsEditService implements IFieldsEditService {

    static $inject = ["OmniaFieldsService"];

    private _targetType: FieldsEditTarget;
    private _field: IField;
    private _crop: ICropping;
    private _isEditing: boolean;

    public multiple: boolean;

    constructor(public readonly svc: IFieldsService) {
    }


    stopEditing() {
        this._targetType = 0;
        this.multiple = false;
        this._isEditing = false;
        this._field = null;
        this._crop = null;
    }

    startEditing(cropping: boolean, target?: IField | ICropping) {
        this._targetType = (cropping ? FieldsEditTarget.Cropping : FieldsEditTarget.Field);
        this._field = (!cropping ? <IField>target : null);
        this._crop = (cropping ? <ICropping>target : null);
        this._isEditing = true;
    }

    get isEditing(): boolean {
        return this._isEditing;
    }

    get targetType(): FieldsEditTarget {
        return this._targetType;
    }

    get field() {
        return this._field
    }

    get fields(): IField[] {

        if (this.multiple) {
            return this.svc.selectedFields.map(f => f.field)
        }

        return [this._field]

    }

    get cropping(): ICropping[] {

        if (this._targetType != FieldsEditTarget.Cropping) return null

        if (this.multiple) {

            return this.svc.selectedCroppings.map(c => c.cropping)

        }

        return [this._crop];
    }

    canSelectAsEditTarget(item: FieldViewModel): boolean {

        const { targetType, multiple, _field } = this
        if (!targetType) return true;

        if (!!_field) {

            if (!item.isField()) {
                return false
            }

            return (!multiple) || (_field.FieldId == item.fieldId)

        }

        if (item.isCropping()) {

            if (!multiple) {
                return (this._crop.CroppingId == item.croppingId)
            }

            if (this._crop && (this._crop.YearId != item.yearId)) {
                return false
            }

            else if (item.isUsedInPlans()) {
                return false;
            }

            return true;

        }

        return false;

    }

    selectCropping(cropping: FieldViewModel, select): boolean {

        if ((this.targetType == FieldsEditTarget.Cropping) && (!!this._crop) && this.multiple) {

            var selection = this.cropping;

            var selected = !!selection.find(c => c.CroppingId == cropping.croppingId);

            if (!selected) {

                if (select && this.canSelectAsEditTarget(cropping)) {
                    selection.push(cropping.cropping);
                    this.selectCroppingInternal(selection);
                    return true;
                }

                return false;

            }
            else {

                if ((!select) && (selection.length > 1)) {

                    selection = selection.filter(s => s.CroppingId != cropping.croppingId);

                    this.selectCroppingInternal(selection);

                    if (cropping.croppingId == this._crop.CroppingId) {
                        this._crop = selection[0];
                    }

                }

            }


        }

        return false;

    }

    private selectCroppingInternal(cropping: ICropping[]) {

        var selection = this.svc.cropping.filter(c => cropping.some(s => s.CroppingId == c.croppingId));

        this.svc.selectItems(selection, true);

    }


}
